import React, { useEffect, useState } from 'react';
import { Widget, FormSelect, FormInput, FormSubmitButton, FormatText } from '@digital/ui';
import { SelectValue } from 'antd/lib/select';
import { hasPermission } from '@app/helpers/permissions';
import { TipoOptions } from '@app/api/api';
import { CrfAcronimoProjeto } from '@app/api/crf/acronimo/projeto/crfAcronimosProjeto';
import { CrfProjeto, updateAcronimoNoCrfProjeto } from '@app/api/crf/crfProjeto';

interface FormAcronimoProjetoProps {
  selectedItem: CrfProjeto;
  acronimos: CrfAcronimoProjeto[];
  projetoDisciplina: TipoOptions[];
}

const FormCrfAcronimoProjeto = (props: FormAcronimoProjetoProps) => {
  const { acronimos, selectedItem, projetoDisciplina } = props;
  const [acronimoSelecionado, setAcronimoSelecionado] = useState<CrfAcronimoProjeto>();

  const [disciplinaSelecionada, setDisciplinaSelecionada] = useState<string>("");

  useEffect(() => {
    const getAcronimoInfo = () => {
      const data = acronimos.find(a => a.id === selectedItem.acronimoProjetoId);
      if (data) setAcronimoSelecionado(data);
    };
    if (selectedItem && selectedItem.acronimoProjetoId) {
      getAcronimoInfo();
    }

    if (selectedItem && selectedItem.crfProjetoDisciplinaId) {
      const disciplina = projetoDisciplina.find(a => a.value === selectedItem.crfProjetoDisciplinaId);
      if (disciplina) setDisciplinaSelecionada(disciplina.value);
    }
  }, [selectedItem, acronimos, projetoDisciplina]);

  const handleUpdate = () => {
    if (selectedItem) {
      updateAcronimoNoCrfProjeto(selectedItem);
    }
  };

  const handleChangeStatus = (value: SelectValue) => {
    if (value) {
      selectedItem.acronimoProjetoId = String(value);
      const data = acronimos.find(a => a.id === value);
      if (data) setAcronimoSelecionado(data);
    }
  };

  const handleChangeDisciplina = (value: SelectValue) => {
    if (value) {
      selectedItem.crfProjetoDisciplinaId = String(value);
      setDisciplinaSelecionada(String(value));
    }
  };

  return (
    <Widget
      title="Acrônimos"
      actions={[
        hasPermission(['PROJETO_ABA_GERAL_EDITAR']) && (
          <FormSubmitButton type="primary" onClick={handleUpdate}>
            <FormatText id="ui.commons.save" uppercase />
          </FormSubmitButton>
        ),
      ]}>
      <FormSelect
        label="Acrônimo"
        name="acronimoProjetoId"
        options={acronimos && acronimos.map(a => ({ text: a.sigla, value: a.id.toString() }))}
        span={3}
        optionFilterProp="children"
        onChange={value => handleChangeStatus(value)}
      />
      <FormInput
        label="Categoria"
        name="categoria"
        span={3}
        value={acronimoSelecionado && acronimoSelecionado.nomeCategoria}
        disabled
      />
      <FormInput
        label="Grupo"
        name="grupo"
        span={3}
        value={acronimoSelecionado && acronimoSelecionado.nomeGrupo}
        disabled
      />
      <FormSelect
        label="Disciplina"
        name="disciplina"
        options={projetoDisciplina}
        value={disciplinaSelecionada}
        span={3}
        optionFilterProp="children"
        onChange={value => handleChangeDisciplina(value)}
      />
    </Widget>
  );
};

export default FormCrfAcronimoProjeto;
